import * as React from 'react';

function SvgDotsThreeVertical(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable={false}
      {...props}
    >
      <path
        d="M16 17.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM16 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM16 25.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgDotsThreeVertical;
